import React, {
    useState
} from "react";

import { Button } from "@mui/material";
import { CreateIssueDialog } from "./CreateIssueDialog";

type CreateIssueButtonProps = {
    buttonProps?: React.ComponentProps<typeof Button>;
    icon?: React.ReactNode;
    text?: string;
};

export const CreateIssueButton = ({
    buttonProps,
    icon,
    text = "New Issue",
}: CreateIssueButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleOpen = () => {
        setIsDialogOpen(true);
    };

    const handleClose = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                {...buttonProps}
                startIcon={icon}
            >
                {text}
            </Button>
            <CreateIssueDialog
                open={isDialogOpen}
                onClose={handleClose}
            />
        </>
    );
};